// src/hooks/useEffectOnce.ts
import { useEffect } from "react";
function useEffectOnce(cb) {
  useEffect(cb, []);
}
export {
  useEffectOnce
};
//# sourceMappingURL=useEffectOnce.mjs.map